module.exports = __webpack_public_path__ + "img/geofisica_16-9_1440.e37c1a6b.webp";